<div libFlexRow>
	@if (!isMobileView()) {
	<div libFlexColumn libFlexFill></div>
	}
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : '400px'">
		<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'16px'">
			@for (button of pricingIntervalButtons(); track button.interval) {
			<div libFlexColumn>
				<lib-button
					(click)="setPricingInterval(button.interval)"
					[buttonType]="activePrice().interval === button.interval ? 'primary' : 'basic'"
					>{{ button.label }}</lib-button
				>
			</div>
			}
		</div>

		<lib-card [removePadding]="true" class="push-top-md">
			<div class="w-price-card">
				<div libPad>
					<div class="w-price-wrapper">
						<span class="w-price">
							{{ activePrice().price }}
						</span>
						<span class="w-price-month">/ {{ activePrice().interval }}</span>
					</div>
					@if (activePrice().discountPercentage) {
					<div class="w-price-discount push-top">
						{{ activePrice().discountPercentage }}
					</div>
					}
					<div class="w-price-features">
						@for (feature of featureList; track feature; let first = $first; let index = $index) {
						<div libFlexRow [libFlexRowGap]="'16px'" class="w-price-feature push-top">
							<div libFlexColumn>
								<lib-icon [color]="'success'" [type]="'check'"></lib-icon>
							</div>
							<div libFlexColumn [class.highlighted]="index <= highlightFeaturesIndex">
								{{ feature }}
							</div>
						</div>
						}
					</div>

					<div class="push-top-xl">
						@if (buttonBehavior() === 'home') {
						<div libFlexRow [libFlexRowAlign]="'center'">
							<div libFlexColumn libFlexFill>
								<lib-button
									[routerLink]="getStartedUrl()"
									[buttonSize]="'full'"
									[buttonType]="'primary'"
									>Get Started</lib-button
								>
							</div>
						</div>
						} @else if (buttonBehavior() === 'subscribe') {
						<div libFlexRow [libFlexRowAlign]="'center'">
							<div libFlexColumn libFlexFill>
								<lib-button
									(click)="handleSubscribe.emit(activePrice().interval)"
									[buttonSize]="'full'"
									[buttonType]="'primary'"
									>Subscribe</lib-button
								>
							</div>
						</div>
						}
					</div>
				</div>
			</div>
		</lib-card>
	</div>
	@if (!isMobileView()) {
	<div libFlexColumn libFlexFill></div>
	}
</div>
